import {flow, getEnv, types} from "mobx-state-tree";
import Notification from "../../../utils/Notification";

const DeleteUtmState = types.model('DeleteRuleSetState', {
  utmName: types.optional(types.string, ""),
  formHasErrors: types.optional(types.boolean, false),
  errorMessage: types.optional(types.string, ""),
  title: types.maybe(types.string),
  uuid: types.maybe(types.string)
})
  .volatile(self => ({
    toggleModal: types.fn,
    refreshList: types.fn,
  }))
  .actions((self) => ({
    handleHasDeleteErrors(boolean) {
      self.formHasErrors = boolean
    },
    handleDeleteErrorMessage(message) {
      self.errorMessage = message
    },
    setToggleListener(listener) {
      self.toggleModal = listener
    },
    setRefreshListener(listener) {
      self.refreshList = listener
    },

    deleteUtm: flow(function* () {

      const manager = getEnv(self).utmManager;
      const resp = yield manager.delete(self)

      !self.formHasErrors && new Notification()
        .setType("success")
        .setMessage(`${self.utmName} UTM deleted`)
        .send();
      !self.formHasErrors && self.refreshList()
      !self.formHasErrors && self.toggleModal()
    }),

  }))

export default DeleteUtmState;
